import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Strip out static imgSrc for dynamically bound images
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag} = jsonNode;

  const isImage = tag && DomTypeUtils.isImage(tag);
  const isDynSrc = DomTypeUtils.isDynBound(data, 'src');
  const hasStaticSrc = Boolean(data && data.attr && data.attr.src);

  return {
    needed: Boolean(isImage && isDynSrc && hasStaticSrc),
    logData: {
      msg: 'dyn-bound image with static src',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      delete data.attr.src; // eslint-disable-line webflow/no-delete
      if (Object.keys(data.attr).length === 0) {
        // eslint-disable-next-line webflow/no-delete
        delete data.attr;
      }
    },
  };
};
